<template>
  <div>
    <img
      src="@/assets/images/line/Frame 1000002302.png"
      alt="lineimg"
      class="m-auto px-4 mob-hidden"
    />
    <div class="lg:py-0 md:py-0 temp-h530 smh-450px lg:flex md:flex relative">
      <!-- <div class="absolute bg-design8 mob-hidden">
        <img
          src="../../../assets/images/dots.svg"
          alt="bg-polygon"
          class="h-full w-full"
        />
      </div> -->
      <div class="absolute bg-design9 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd9.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design10 mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full w-full"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full sm-h420px flex">
        <div class="lg:px-12 md:px-12 px-5 lg:pt-0 md:pt-0 pt-4">
          <p class="title md:font-normal lg:font-normal font-bold sm-fsize20">
            Why Become A Caregiver Coach?
          </p>
          <div class="lg:pt-10 md:pt-10 pt-4">
            <p class="subtitle lh32px sm-fsize16 sm-lh25px">
              We have designed the program to create a new paradigm for
              professionals to offer their services for Caregivers. This will
              help you:
            </p>

            <ul
              class="list-disc lg:pt-10 md:pt-10 pt-2 pl-5 lg:mb-12 md:mb-12 mb-4"
            >
              <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
                To strengthen your offerings to your clients
              </li>
              <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
                To add your volunteering hours with us officially on the ICF
                certification platform (shortly)
              </li>
              <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
                Add to your client base
              </li>
              <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
                Become an early evangelizer of the need to care for the
                caregivers
              </li>
              <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
                Extend your core competencies to a larger community
              </li>
            </ul>
          </div>
          <div class="flex lg:pt-2 md:pt-8">
            <base-button
              type="primary"
              class="buttonlog lg:px-8 md:px-8 lg:py-3 md:py-3 fsize14 lg:my-0 my-2"
              @click="handleDownload(borach.file)"
              >Download Program Brochure</base-button
            >
          </div>
        </div>
      </div>

      <div class="lg:w-1/2 md:w-1/2 lg:pt-0 md:pt-0 w-full">
        <div class="m-auto h-full mob-hidden">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Coaching-why%20become%20a%20caregiver%20coach.jpg"
            alt="medicalcondition"
            class="lg:pr-16 md:pr-16 lg:ml-auto md:ml-auto banner-short-w sm-width83 sm-mxauto"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      medicalcards: [
        {
          id: "01",
          text: "Dementia",

          color: "#cceff2",
          description:
            "Dementia is a generic term for the impaired ability to remember, think, or make decisions. It can be of various kinds, Alzheimer’s being the most common one. Family caregivers of people with dementia are important to the quality of the patient’s life. The effects of being a long-term caregiver often includes psychological burden and social isolation. Our community, support groups and counselling offer you the time and space to share your experiences and unburden your closed emotions.",
        },
        {
          id: "02",
          text: "Cancer",

          color: "#eee2ff",
          description:
            "Cancer diagnosis causes complex feelings and lifestyle changes that can be overwhelming for families. The needs and requirements of caregiving for a cancer patient can vary depending on the type. It is emotionally and financially draining for the majority, especially when it involves palliative care. Our advisory services on financial planning, respite care and home-based care offers you opportunities to create checks and balances for your long-term caregiving needs.",
        },
        {
          id: "03",
          text: "ALS",

          color: "#eee2ff",
          description:
            "Amyotrophic Lateral Sclerosis or ALS is a neurodegenerative disorder that progressively leads to loss of voluntary muscle movements. Currently, there is no cure for ALS, and neither any effective treatment to halt or reverse the progression of the disease. Informal caregiving for a loved one with ALS can be physically and mentally stressful. Our educational resources and learning programmes can equip you with better knowledge and skills to provide effective caregiving. Simultaneously, our support services enable you to focus on your well-being.",
        },
        {
          id: "04",
          text: "Mental Illness",

          color: "#cceff2",
          description:
            "Mental Illness refers to a wide range of mental health disorders that affect one’s mood, thinking and behaviour. Some common illnesses are depression, schizophrenia, and addiction. Primary caregivers of people with mental illnesses must bear with extreme behavioural disturbances which can cause considerable distress and anxiety. We help you cope with these circumstances through community support, guidance, and counselling services.",
        },
      ],
    };
  },
  methods: {
    // async handleDownload({ url, label }) {
    //   const response = await axios.get(url, { responseType: "blob" });
    //   const blob = new Blob([response.data], { type: "application/pdf" });
    //   const link = document.createElement("a");
    //   link.href = URL.createObjectURL(blob);
    //   link.download = label;
    //   link.click();
    //   URL.revokeObjectURL(link.href);
    // },
    handleDownload(file) {
      window.open(this.$imageURL + "/" + this.borach[0].file, "_blank");
    },
  },
  async created() {
    try {
      await this.$store.dispatch("coach/GetBrochure");
    } catch (err) {
      console.log(err);
    }
  },
  computed: {
    ...mapState("coach", {
      borach: "borach",
    }),
  },
};
</script>
